import Typography from '@mui/material/Typography'
import {HealthConditionSubTitle} from '../HealthCondition/HealthConditionStyle'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import {StyledCustomLabels, StyledTitleContainer} from '../../AdminPanelStyling'
import PropTypes from 'prop-types'
import {Box, Grid} from '@mui/material'
import {useConfig} from '../../../store/hooks/config'
import {formatPersonas, SECTIONS} from '../../customSettings/Customization/helper'
import {ChatbotGrid, ToggleStack} from '../chatbot/ChatbotCopyStyle'

const PersonaFlag = ({selectedPersona, setselectedPersona, showCustomLabels, setCustomLabelDialogProps}) => {
  const {personasConfig} = useConfig()

  const setselectedTogglefunction = () => {
    setselectedPersona([1 - selectedPersona[0]])
  }

  return (
    <Box tabIndex={0} aria-label='persona toggle'>
      {showCustomLabels && (
        <StyledTitleContainer>
          <Box flex={1} />
          <StyledCustomLabels
            flex={1}
            mr={2}
            display='flex'
            justifyContent='flex-end'
            variant='CustomSettings'
            onClick={() => {
              setCustomLabelDialogProps({
                open: true,
                section: SECTIONS.PERSONAS,
                data: formatPersonas(personasConfig) || []
              })
            }}
          >
            Customize Labels
          </StyledCustomLabels>
        </StyledTitleContainer>
      )}
      <ChatbotGrid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HealthConditionSubTitle tabIndex={0}>
            This will allow users to interact with the Behavioral Persona on the dashboard map view, users can access
            the individual persona characteristics and summary report.
          </HealthConditionSubTitle>
        </Grid>
        <Grid item xs={12} md={6}>
          <ToggleStack>
            <Typography>Off</Typography>
            <TemporaryToggle
              checked={selectedPersona?.length > 0 ? selectedPersona[0] : false}
              onChange={setselectedTogglefunction}
              aria-label='Behavioral Persona Toggle Button'
            />
            <Typography>On</Typography>
          </ToggleStack>
        </Grid>
      </ChatbotGrid>
    </Box>
  )
}

PersonaFlag.propTypes = {
  selectedPersona: PropTypes.any.isRequired,
  setselectedPersona: PropTypes.func.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func.isRequired
}

export default PersonaFlag
